import { Injectable } from '@angular/core';
import { SafeArea } from '@capacitor-community/safe-area';
import { Capacitor } from '@capacitor/core';
import { ModuleLoaderService } from '../../shared/services/module-loader.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  constructor(
    private moduleLoader: ModuleLoaderService
  ) {
  }

  initializeApp() {
    this.setupSafeArea();
    this.moduleLoader.setupSocialLogin();
    if (Capacitor.isNativePlatform()) {
      this.moduleLoader.notifyUpdaterReady();
    }
  }
  
  private async setupSafeArea(): Promise<void> {
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    
    SafeArea.enable({
      config: {
        statusBarContent: prefersDark ? "light" : "dark",
        navigationBarContent: prefersDark ? "light" : "dark",
        customColorsForSystemBars: true,
        statusBarColor: '#00000000', // transparent
        navigationBarColor: '#00000000', // transparent
      },
    });
  }
} 